import { Box, SxProps, Theme, alpha } from '@mui/material';
import { useState } from 'react';

interface BarChartResizeHandleProps {
  onResize: (widthDifference: number) => void;
  sxProps: SxProps<Theme>;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseUp?: () => void;
}

export const BarChartResizeHandle = ({
  sxProps,
  onResize,
  onMouseDown,
  onMouseUp,
}: BarChartResizeHandleProps) => {
  const [isActive, setIsActive] = useState(false);
  const [shouldShowResizeHandle, setShouldShowResizeHandle] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    setIsActive(true);
    onMouseDown?.(event);
    const initialMouseX = event.clientX;

    function handleMouseMove(event: MouseEvent) {
      const currentMouseX = event.clientX;
      const widthDifference = currentMouseX - initialMouseX;
      onResize(widthDifference);
    }

    function handleMouseUp() {
      setIsActive(false);
      onMouseUp?.();
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <Box
      height="100%"
      sx={{ cursor: 'col-resize', ...sxProps }}
      onMouseEnter={() => setShouldShowResizeHandle(true)}
      onMouseLeave={() => setShouldShowResizeHandle(false)}
      onMouseDown={handleMouseDown}
    >
      <Box
        width="4px"
        height="100%"
        bgcolor={(theme) =>
          alpha(theme.palette.primary.main, isActive ? 0.5 : 1)
        }
        sx={{
          m: 'auto',
          opacity: shouldShowResizeHandle ? 1 : 0,
          transition: 'opacity 0.2s ease-in-out',
        }}
      />
    </Box>
  );
};
